import { getLoginAttributes } from '@/api';
import { AwsCognitoErrorMessages, AuthExceptions } from '@/constants';
import { decrypt, encrypt } from '@/util';

export const getErrorMessage = (exceptionType: string, maxLoginAttempts = 0, attemptsCount = 0) => {
  return (AwsCognitoErrorMessages(maxLoginAttempts - attemptsCount) as any)[exceptionType] || '';
}

export const handleNotAuthorizedException = async (email: string, message: string) => {
  if (message.includes('User is disabled.')) {
    return getErrorMessage(AuthExceptions.UserNotFoundException);
  }
  const { attemptsCount, maxLoginAttempts, isConfirmed } = await getLoginAttributes(email);
  if (!isConfirmed) {
    return getErrorMessage(AuthExceptions.UserNotFoundException);
  } else if (attemptsCount === maxLoginAttempts) {
    return getErrorMessage(AuthExceptions.UserLambdaValidationException);
  } else {
    return getErrorMessage(AuthExceptions.NotAuthorizedException, maxLoginAttempts, attemptsCount);
  }
}

export const getActivePortalAccount = (attributes: any) => attributes['custom:activePortalAccount'];

const bakeCookie = (cookieName: string, userCreds: object) => {
  const credentials = encrypt(userCreds);
  document.cookie = `${cookieName}= ${credentials} =; expires=Thu, 01-Jan-2037 00:00:01 GMT`;
}

export const readCookie = (cookieName: string) => {
  const cookie = document.cookie.match(new RegExp(cookieName + '=([^;]+)')) || '';
  return cookie ? decrypt(cookie[1]) : cookie;
}

const deleteCookie = (cookieName: string, userCred: any) => {
  const storedUser = readCookie('userCred');
  if (storedUser && storedUser.email === userCred.email && storedUser.password === userCred.password) {
    document.cookie = `${cookieName} =; expires=Thu, 01-Jan-1970 00:00:01 GMT`;
  }
}

export const isRememberMe = (rememberMe: boolean, email: string, password: string) => {
  const userCreds = {
    email,
    password,
    rememberMe
  }
  if (rememberMe && email !== '') {
    bakeCookie('userCred', userCreds);
  } else {
    deleteCookie('userCred', userCreds);
  }
}
